export class CouldNotDemoteLastAdminUserInOrganization extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, CouldNotDemoteLastAdminUserInOrganization.prototype)
  }
}
